<template>
  <div>
    <div
      class="context-menu wd-200 tx-13"
      ref="popper"
      v-show="isVisible"
      tabindex="-1"
      v-click-outside="close"
      @contextmenu.capture.prevent
    >
      <ul class="nav nav-pills flex-column bd">
        <slot :contextData="contextData" />
      </ul>
    </div>

    <b-overlay :show="busy" no-wrap>
      <template #overlay>
        <div
          v-if="processing"
          class="text-center p-4 bg-secondary text-light rounded"
        >
          <b-icon icon="info" font-scale="4"></b-icon>
          <div class="mb-3">Түр хүлээнэ үү...</div>
          <b-progress
            min="1"
            max="20"
            :value="16"
            variant="warning"
            height="5px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Итгэлтэй байна уу?</strong>
          </p>
          <div class="d-flex">
            <b-button
              variant="outline-danger"
              class="mr-3"
              @click="busy = false"
              >Үгүй</b-button
            >
            <b-button
              @click="
                processing = true;
                $emit('on-task-delete', { id: contextData.id });
              "
              variant="outline-success"
              >Тийм</b-button
            >
          </div>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import Popper from "popper.js";
import ClickOutside from "vue-click-outside";
// @vue/component
export default {
  props: {
    boundariesElement: {
      type: String,
      default: "body"
    }
  },
  components: {
    Popper
  },
  data() {
    return {
      opened: false,
      contextData: { id: null, task: null },

      busy: false,
      processing: false
    };
  },
  directives: {
    ClickOutside
  },
  computed: {
    isVisible() {
      return this.opened;
    }
  },
  methods: {
    open(evt, contextData) {
      this.opened = true;
      this.contextData = contextData;

      if (this.popper) {
        this.popper.destroy();
      }

      this.popper = new Popper(this.referenceObject(evt), this.$refs.popper, {
        placement: "right-start",
        modifiers: {
          preventOverflow: {
            boundariesElement: document.querySelector(this.boundariesElement)
          }
        }
      });
      this.$nextTick(() => {
        this.popper.scheduleUpdate();
      });
    },
    close() {
      this.opened = false;
      this.contextData = { id: null, task: null };
    },
    deleteItem(e) {
      this.opened = false;
      this.busy = true;
    },
    deleteAfter() {
      this.busy = false;
      this.contextData = { id: null, task: null };
      this.processing = false;
    },
    referenceObject(evt) {
      const left = evt.clientX;
      const top = evt.clientY;
      const right = left + 1;
      const bottom = top + 1;
      const clientWidth = 1;
      const clientHeight = 1;

      function getBoundingClientRect() {
        return {
          left,
          top,
          right,
          bottom
        };
      }

      const obj = {
        getBoundingClientRect,
        clientWidth,
        clientHeight
      };
      return obj;
    }
  },
  beforeDestroy() {
    if (this.popper !== undefined) {
      this.popper.destroy();
    }
  }
};
</script>

<style lang="scss" scoped>
.context-menu {
  position: fixed;
  z-index: 999;
  overflow: hidden;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 #eee;

  &:focus {
    outline: none;
  }

  ul {
    padding: 0px;
    margin: 0px;
  }
}
</style>
